export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8064.053ce70e.jpg";